/**
 * Created by karlaelliott on 11/03/17.
 */
dealershipModule.factory('internetQuotingService',
    ['$q', 'AppSettings', 'userAuthenticateService', 'commonRESTCallService', 'commonTLCService', 'InternetQuotingInfo', 'imSessionVarsService',
        'erateSessionVarsService',
        function ($q, AppSettings, userAuthenticateService, commonRESTCallService, commonTLCService, InternetQuotingInfo, imSessionVarsService,
                  erateSessionVarsService) {
            var internetQuotingAPI = {};
            var myRSSApplicationURL = AppSettings.startIdentitySvcURL + 'rssapplications/application/';
            var myToken = '';


            internetQuotingAPI.getDealership = function(id) {
                var promiseWrapper = $q.defer();

                keepTokenCurrent();

                var getDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/";
                commonRESTCallService.getFromServerWithToken(getDealershipUrl, myToken)
                    .success(function(responseData, status) {
                        var dealer = new InternetQuotingInfo();
                        myRSSApplicationURL = myRSSApplicationURL + "ProductPricingPortal";
                        commonRESTCallService.getFromServerWithToken(myRSSApplicationURL, myToken)
                            .success(function(responseRSSApplicationData, status) {
                                if (responseRSSApplicationData.Id) {
                                    imSessionVarsService.setProductPricingPortalId(responseRSSApplicationData.Id);
                                    dealer.populateDataFromIdentityManagement(responseData, responseRSSApplicationData.Id);
                                    promiseWrapper.resolve(dealer);
                                }
                                else {
                                    promiseWrapper.reject(responseData);
                                }
                            }).error(function(responseData, status) {
                            promiseWrapper.reject(responseData);
                        });
                    }).error(function(responseData, status) {
                    promiseWrapper.reject(responseData);
                });

                return promiseWrapper.promise;
            };


            internetQuotingAPI.updateInternetQuoting = function(id, internetQuotingInfo, previousInternetQuotingInfo) {
                keepTokenCurrent();

                var promises = [];

                // Add promise to turn the Internet Quoting on/off
                var internetQuotingPromise = tryUpdateInternetQuotingOption(id, internetQuotingInfo, previousInternetQuotingInfo);
                if(internetQuotingPromise)
                    promises.push(internetQuotingPromise);

                // Add promise to save email addresses
                var emailsPromise = tryUpdateEmails(id, internetQuotingInfo, previousInternetQuotingInfo);
                if(emailsPromise)
                    promises.push(emailsPromise);

                // Add promise to generate link
                var generateLinkPromise = tryGenerateLink(id, internetQuotingInfo, previousInternetQuotingInfo);
                if(generateLinkPromise)
                    promises.push(generateLinkPromise);

                return $q.all(promises);
            };

            function keepTokenCurrent() {
                if(!myToken)
                    myToken = userAuthenticateService.getUserToken();
            }

            return internetQuotingAPI;
        }
    ]);